// class dT_CompareList {

//     constructor() {
//         this.CompareListData = [];

//         this.LOCAL_STORAGE_CompareLIST_KEY = 'shopify-Comparelist';
//         this.LOCAL_STORAGE_DELIMITER = ',';
//     }

//     setListLocalStorageKey(LOCAL_STORAGE_CompareLIST_KEY, LOCAL_STORAGE_DELIMITER) {
//         this.LOCAL_STORAGE_CompareLIST_KEY = LOCAL_STORAGE_CompareLIST_KEY;
//         this.LOCAL_STORAGE_DELIMITER = LOCAL_STORAGE_DELIMITER;
//     }

//     setupGrid(listType) {
//         var Comparelist = this.getComparelist();

//         var requests = Comparelist.map(function (handle) {
//             var productTileTemplateUrl = '/products/' + handle + '?view=json';

//             var getProductsList =  this.getProductResponse(productTileTemplateUrl);

//             return getProductsList;
//         }.bind(this));
      

//        return Promise.all(requests).then(function (responses) {
//               var ComparelistProductCards = responses.join('%$$%');
//               var ComparelistProductCards = ComparelistProductCards;

//               var a_ComparelistRecords = ComparelistProductCards.split("%$$%");

//               let recordsObj = [];

//               if (Array.isArray(a_ComparelistRecords) && a_ComparelistRecords.length) {
//                   var index = 0;
//                   a_ComparelistRecords.forEach(record => {
//                       var a_record = record.split("~~");

//                       var recordObj = {
//                               id:             a_record[0],
//                               product_title:  a_record[1],
//                               product_handle: a_record[2],
//                               product_image:  a_record[3],
//                               vendor:         a_record[4],
//                               type:           a_record[5],
//                               money_price:    a_record[6],
//                               price_min:      a_record[7],
//                               price_max:      a_record[8],
//                               available:      a_record[9],
//                               price_varies:   a_record[10],
//                               variant_id:     a_record[11],
//                               variant_title:  a_record[12],
//                               sku:            a_record[13],
//                               description:    a_record[14],
//                               quantity:       "1",
//                               product_url:    '/products/'+a_record[2]
//                       };

//                       recordsObj[index] = recordObj;

//                       index = index + 1;

//                   });

//               }

//               return recordsObj;

//          }).then(function(data) {
         
//              this.CompareListData = data;  
         
//              return data;

//          }.bind(this));

//     }

//     getCompareListRecords()
//     {
//         return this.CompareListData;
//     }


//     getProductResponse(url) {
            
//       var responseResult = fetch(url)
//       	.then((response) => { 
//           //console.log(response); 
//           return response.text(); })
//       	.then((data) => { 
//           //console.log(data); 
//       return data.replace(/^\s*[\r\n]/gm, ''); });     
//       return responseResult;
      
//     }

//     getTotalCount() {
// 		return this.getComparelist().length;
//     }
  
//     getComparelist() {
//         var Comparelist = localStorage.getItem(this.LOCAL_STORAGE_CompareLIST_KEY) || false;
//         if (Comparelist) return Comparelist.split(this.LOCAL_STORAGE_DELIMITER);
//         return [];
//     }

//     setComparelist(array) {
//         var Comparelist = array.join(this.LOCAL_STORAGE_DELIMITER);
//         if (array.length) localStorage.setItem(this.LOCAL_STORAGE_CompareLIST_KEY, Comparelist);
//         else localStorage.removeItem(this.LOCAL_STORAGE_CompareLIST_KEY);
//         return Comparelist;
//     }

//     updateComparelist(handle) {
//         var Comparelist = this.getComparelist();
//         var indexInComparelist = Comparelist.indexOf(handle);
//         if (indexInComparelist === -1) Comparelist.push(handle);
//         else Comparelist.splice(indexInComparelist, 1);
//         return this.setComparelist(Comparelist);
//     }

//     removeComparet(handle) {
//         var Comparelist = this.getComparelist();

//         Comparelist = this.remove(Comparelist, handle);

//         return this.setComparelist(Comparelist);  
//     }

//     resetComparelist() {
//         return this.setComparelist([]);
//     }

//     isAddedIntoList(handle) {
//         var Comparelist = this.getComparelist();  
        
//         return Comparelist.includes(handle);
//     }

//     remove(arr) {
//         var what, a = arguments, L = a.length, ax;
//         while (L > 1 && arr.length) {
//             what = a[--L];
//             while ((ax= arr.indexOf(what)) !== -1) {
//                 arr.splice(ax, 1);
//             }
//         }
//         return arr;
//     };
// }

// async function getDTProduct(url) {
    
 
//     try {
//       let res = await fetch(url);

//       return res.text().then(function (text) {      
//         return text;
//       });

        
//     } catch (error) {
//         console.log(error);
//     }
// }

// class dTXCompare extends HTMLElement {
//     constructor() {
//       super();

//       this.dTCompareList = new dT_CompareList();
//       this.dTCompareList.setListLocalStorageKey('dt-compare-list', ',');

//       this.debouncedOnSubmit = debounce((event) => {
//         this.onSubmitHandler(event);
//       }, 500);


//       this.addCompareList = this.querySelector('.add-compare');
//       this.productHandle = this.addCompareList.getAttribute('data-product_handle');

//       this.addCompareList.addEventListener('click', this.debouncedOnSubmit.bind(this));

//       this.initLoad();
//     }

//     onSubmitHandler(event) {
//         event.preventDefault();

//         if (this.dTCompareList.isAddedIntoList(this.productHandle)) {
//              window.location = "/pages/compare";
//         } else {
//           const CompTotal = this.dTCompareList.getTotalCount();
       
//     if (CompTotal > 3) {   
//         var CompareModal = document.getElementById("compareModal");
//         var XBtn = document.getElementById("compareModalClose");
//         document.querySelector('body').classList.add('overflow-hidden');
//         var myModal = new bootstrap.Modal(document.getElementById('compareModal'));
//         myModal.show();
//         XBtn.onclick = function() {
//         myModal.hide();
//         document.querySelector('body').classList.remove('overflow-hidden');
//       }    
      
//       const AnItem = this.productHandle
//       delete localStorage.AnItem;
//       return;
//     }
//           else {
          
//             this.addCompareList.classList.add("adding");

//             this.dTCompareList.updateComparelist(this.productHandle);

//             setTimeout(this.postAdd.bind(this), 1000);
//           }
//         }
//     }

//     postAdd() {
//        var dtxCount = document.getElementsByClassName('dtxc-compare-count');
//     if (dtxCount.length > 0) {
//     document.querySelector(".dtxc-compare-count").setAttribute('count',this.dTCompareList.getTotalCount());
//     } 
//         this.addCompareList.classList.remove("adding");
//         this.addCompareList.classList.add("added");   
//     }

//     initLoad() {
//         if (this.dTCompareList.isAddedIntoList(this.productHandle)) {
//             this.addCompareList.classList.add("added");
//         }    
//     }
// }    

// customElements.define('dtx-compare', dTXCompare);

// class dTXComparetGrid extends HTMLElement {
//     constructor() {
//         super();
         
//         this.gridTemplate = this.querySelector('.grid_template');

//         this.dtxTable = this.querySelector(".dtx-table");
//         this.dtxNoRecord = this.querySelector(".dtx-grid-empty");
      
//         this.grid_type = this.getAttribute('grid_type');     
//         //this.initLoad();
       
//     }

//     initLoad() {

//         var dTCompareList = new dT_CompareList();
//         if ("compareList" == this.grid_type) {
//           dTCompareList.setListLocalStorageKey('dt-compare-list', ',');
//         }
        
//         dTCompareList.setupGrid().then(function(data) {
//            this.generateGrid(data);          
//            return data;
//         }.bind(this));  

//        var dtxCount = document.getElementsByClassName('grid-count-bubble');      
 
//    }
  
//    generateGrid(a_records) {
//     var data = this.gridTemplate.innerHTML;

//     if (typeof a_records[0].product_handle !== 'undefined') {
//         if (a_records.length > 0) {
//             a_records.forEach(function(record) {
//                 // Create a new div element for the grid item
//                 var newRow = document.createElement('div');
//                 newRow.id = 'row_' + record.id;
//                 newRow.classList.add('dtx-grid-item', 'col' , 'border-end'); // Adding a class to the grid item

//                 // Generate the inner HTML using the buidRow function
//                 newRow.innerHTML = this.buidRow(record);

//                 // Append the new grid item to the grid container
//                 this.dtxTable.appendChild(newRow);
//             }.bind(this));

//             // Show the grid and hide the "no records" message
//             this.dtxNoRecord.classList.add("dtx-grid-hide");
//             this.dtxTable.classList.add("dtx-grid-show");
//         }
//     } else {
//         // Hide the grid and show the "no records" message
//         this.dtxTable.classList.add("dtx-grid-hide");
//         this.dtxNoRecord.classList.add("dtx-grid-show");
//     }
// }

  
//   buidRow(record) {
//     var templateData = this.gridTemplate.innerHTML;    
//     templateData = templateData.replace(/{item.product_handle}/gi, record.product_handle);
//     templateData = templateData.replace(/{item.product_url}/gi,    record.product_url);
//     templateData = templateData.replace(/{item.product_image}/gi,  record.product_image);
//     templateData = templateData.replace(/{item.product_title}/gi,  record.product_title);
//     templateData = templateData.replace(/{item.money_price}/gi,    record.money_price);
//     templateData = templateData.replace(/{item.variant_id}/gi,     record.variant_id);    
//     if(record.type){    
//     templateData = templateData.replace(/{item.product_type}/gi,   record.type);
//     }
//     else {
//      templateData = templateData.replace(/{item.product_type}/gi,   'Nil'); 
//     }   
//      if(record.sku){      
//     templateData = templateData.replace(/{item.product_sku}/gi,    record.sku);
//     }
//     else {
//      templateData = templateData.replace(/{item.product_sku}/gi,    'Nil');
//     }
//     if(record.vendor){      
//     templateData = templateData.replace(/{item.product_vendor}/gi, record.vendor);
//     }
//     else {
//      templateData = templateData.replace(/{item.product_vendor}/gi,    'Nil');
//     }
//      if(record.description){   
//     templateData = templateData.replace(/{item.product_description}/gi,    record.description);
//      }
//     else {
//      templateData = templateData.replace(/{item.product_description}/gi,    'Nil');
//     }
//     if(record.available == 'true') {
//     templateData = templateData.replace(/{item.available}/gi,     wdtTheme.strings.in_stock);  
//     }
//     else {
//     templateData = templateData.replace(/{item.available}/gi,     window.variantStrings.soldOut);
//     }
//     return templateData;       
    
//   }
  
//   connectedCallback() {
//     // console.log('Custom square element added to page.');
//      this.initLoad();
   
//   }
  
  
// }

// customElements.define('dtx-compare-grid', dTXComparetGrid);

// class dTXRemoveCompareItem extends HTMLElement {
  
//     constructor() {
//         super();
         
//         this.removeItem = this.querySelector('.btn-close');


//         this.debouncedOnSubmit = debounce((event) => {
//       	  this.removeListItem(event);
//       	}, 500);

      
//         this.grid_type = this.getAttribute('grid_type');
      
//         this.productHandle = this.removeItem.getAttribute('data-product_handle');

//         this.removeItem.addEventListener('click', this.debouncedOnSubmit.bind(this));

//     }
  
//     removeListItem(event)
//     {
//       event.preventDefault();
      
//       var dTCompareList = new dT_CompareList();
//       if ("compareList" == this.grid_type) {
//         dTCompareList.setListLocalStorageKey('dt-compare-list', ',');
//       }
        

//       dTCompareList.removeComparet(this.productHandle);
      
//       window.location.reload();
//     }  
  
// }

// customElements.define('dtx-remove-compare-item', dTXRemoveCompareItem);

// class dTXCompareCount extends HTMLElement {
  
//   static get observedAttributes() {
//     return ['count'];
//   }  
  
//   constructor() {
//       super();
         
//       this.gridCountBubble = this.querySelector('.grid-count-bubble');
      
//       this.grid_type = this.getAttribute('grid_type');
     
//       this.initLoad();
//   }
  
//   initLoad() {

//       var dTCompareList = new dT_CompareList();
//       if ("compareList" == this.grid_type) {
//         dTCompareList.setListLocalStorageKey('dt-compare-list', ',');
//       }
      
//       var totalCount = dTCompareList.getTotalCount();
      
//       //this.setAttribute('count', totalCount);   
//       this.gridCountBubble.querySelector("span").innerHTML = totalCount;
     
//     const loadCount = this.gridCountBubble.querySelector("span").innerHTML;
//     if(parseInt(loadCount) == 0) {   
//       document.querySelector('.dtxc-compare-count').classList.add('count-zero');
//     } else{
//       document.querySelector('.dtxc-compare-count').classList.add('count-exist');
//     }
    
//   }
  
//   attributeChangedCallback(name, oldValue, newValue) {
//       this.initLoad();
//   }
  
  
// }

// customElements.define('dtx-compare-count', dTXCompareCount);




class dT_CompareList {
    constructor() {
        this.CompareListData = [];
        this.LOCAL_STORAGE_CompareLIST_KEY = 'shopify-Comparelist';
        this.LOCAL_STORAGE_DELIMITER = ',';
    }

    setListLocalStorageKey(LOCAL_STORAGE_CompareLIST_KEY, LOCAL_STORAGE_DELIMITER) {
        this.LOCAL_STORAGE_CompareLIST_KEY = LOCAL_STORAGE_CompareLIST_KEY;
        this.LOCAL_STORAGE_DELIMITER = LOCAL_STORAGE_DELIMITER;
    }

    setupGrid(listType) {
        var Comparelist = this.getComparelist();

        var requests = Comparelist.map(function (handle) {
            var productTileTemplateUrl = '/products/' + encodeURIComponent(handle) + '?view=json';
            var getProductsList = this.getProductResponse(productTileTemplateUrl);
            return getProductsList;
        }.bind(this));

        return Promise.all(requests).then(function (responses) {
            return responses.filter(function (record) {
                return record && record.handle;
            }).map(function (record) {
                return {
                    id: String(record.id || ''),
                    product_title: String(record.title || ''),
                    product_handle: String(record.handle || ''),
                    product_image: String(record.image || ''),
                    vendor: String(record.vendor || ''),
                    type: String(record.type || ''),
                    money_price: String(record.money_price || ''),
                    price_min: record.price_min,
                    price_max: record.price_max,
                    available: record.available === true,
                    price_varies: record.price_varies === true,
                    variant_id: String(record.variant_id || ''),
                    variant_title: String(record.variant_title || ''),
                    sku: String(record.sku || ''),
                    description: String(record.description || ''),
                    quantity: "1",
                    product_url: String(record.url || '')
                };
            });
        }).then(function (data) {
            this.CompareListData = data;
            return data;
        }.bind(this));
    }

    getCompareListRecords() {
        return this.CompareListData;
    }

    getProductResponse(url) {
        var responseResult = fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Unable to load comparison product.');
                }
                return response.json();
            });
        return responseResult;
    }

    getTotalCount() {
        return this.getComparelist().length;
    }

    getComparelist() {
        var Comparelist = localStorage.getItem(this.LOCAL_STORAGE_CompareLIST_KEY) || false;
        if (Comparelist) return Comparelist.split(this.LOCAL_STORAGE_DELIMITER);
        return [];
    }

    setComparelist(array) {
        var Comparelist = array.join(this.LOCAL_STORAGE_DELIMITER);
        if (array.length) localStorage.setItem(this.LOCAL_STORAGE_CompareLIST_KEY, Comparelist);
        else localStorage.removeItem(this.LOCAL_STORAGE_CompareLIST_KEY);
        return Comparelist;
    }

    updateComparelist(handle) {
        var Comparelist = this.getComparelist();
        var indexInComparelist = Comparelist.indexOf(handle);
        if (indexInComparelist === -1) Comparelist.push(handle);
        else Comparelist.splice(indexInComparelist, 1);
        return this.setComparelist(Comparelist);
    }

    removeComparet(handle) {
        var Comparelist = this.getComparelist();
        Comparelist = this.remove(Comparelist, handle);
        return this.setComparelist(Comparelist);
    }

    resetComparelist() {
        return this.setComparelist([]);
    }

    isAddedIntoList(handle) {
        var Comparelist = this.getComparelist();
        return Comparelist.includes(handle);
    }

    remove(arr) {
        var what, a = arguments, L = a.length, ax;
        while (L > 1 && arr.length) {
            what = a[--L];
            while ((ax = arr.indexOf(what)) !== -1) {
                arr.splice(ax, 1);
            }
        }
        return arr;
    };
}

async function getDTProduct(url) {
    try {
        let res = await fetch(url);
        return res.text().then(function (text) {
            return text;
        });
    } catch (error) {
        console.log(error);
    }
}

class dTXCompare extends HTMLElement {
    constructor() {
        super();

        this.dTCompareList = new dT_CompareList();
        this.dTCompareList.setListLocalStorageKey('dt-compare-list', ',');

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 500);

        this.addCompareList = this.querySelector('.add-compare');
        this.productHandle = this.addCompareList.getAttribute('data-product_handle');

        this.addCompareList.addEventListener('click', this.debouncedOnSubmit.bind(this));

        this.initLoad();
    }

    onSubmitHandler(event) {
        event.preventDefault();

        if (this.dTCompareList.isAddedIntoList(this.productHandle)) {
            window.location = "/pages/compare";
        } else {
            const CompTotal = this.dTCompareList.getTotalCount();
            if (CompTotal > 3) {
                var CompareModal = document.getElementById("compareModal");
                var XBtn = document.getElementById("compareModalClose");
                document.querySelector('body').classList.add('overflow-hidden');
                var myModal = new bootstrap.Modal(document.getElementById('compareModal'));
                myModal.show();
                XBtn.onclick = function () {
                    myModal.hide();
                    document.querySelector('body').classList.remove('overflow-hidden');
                }

                const AnItem = this.productHandle
                delete localStorage.AnItem;
                return;
            }
            else {
                this.addCompareList.classList.add("adding");
                this.dTCompareList.updateComparelist(this.productHandle);
                setTimeout(this.postAdd.bind(this), 1000);
            }
        }
    }

    postAdd() {
        var dtxCount = document.getElementsByClassName('dtxc-compare-count');
        if (dtxCount.length > 0) {
            document.querySelector(".dtxc-compare-count").setAttribute('count', this.dTCompareList.getTotalCount());
        }

        this.addCompareList.classList.remove("adding");
        this.addCompareList.classList.add("added");
    }

    initLoad() {
        if (this.dTCompareList.isAddedIntoList(this.productHandle)) {
            this.addCompareList.classList.add("added");
        }
    }
}

customElements.define('dtx-compare', dTXCompare);

class dTXComparetGrid extends HTMLElement {
    constructor() {
        super();

        this.gridTemplate = this.querySelector('.grid_template');
        this.dtxTable = this.querySelector(".dtx-table");
        this.dtxNoRecord = this.querySelector(".dtx-grid-empty");
        this.grid_type = this.getAttribute('grid_type');
    }

    initLoad() {
        var dTCompareList = new dT_CompareList();
        if ("compareList" == this.grid_type) {
            dTCompareList.setListLocalStorageKey('dt-compare-list', ',');
        }

        dTCompareList.setupGrid().then(function (data) {
            this.generateGrid(data);
            return data;
        }.bind(this));

        var dtxCount = document.getElementsByClassName('grid-count-bubble');
    }

    generateGrid(a_records) {
        if (Array.isArray(a_records) && a_records.length > 0) {
            a_records.forEach(function (record) {
                this.dtxTable.appendChild(this.buildRow(record));
            }.bind(this));

            this.dtxNoRecord.classList.add("dtx-grid-hide");
            this.dtxTable.classList.add("dtx-grid-show");
            this.dtxTable.classList.remove("d-none");
        } else {
            this.dtxTable.classList.add("dtx-grid-hide");
            this.dtxTable.classList.add("d-none");
            this.dtxNoRecord.classList.remove("dtx-grid-hide");
        }
    }

    buildRow(record) {
        var rowFragment = this.gridTemplate.content.cloneNode(true);
        var newRow = rowFragment.querySelector('.dtx-grid-item');
        var productUrl = this.getSafeProductUrl(record.product_url, record.product_handle);
        var productImage = this.getSafeImageUrl(record.product_image);
        var variantId = /^\d+$/.test(record.variant_id) ? record.variant_id : '';

        newRow.id = 'row_' + record.product_handle;

        newRow.querySelectorAll('[data-compare-product-link]').forEach(function (link) {
            link.setAttribute('href', productUrl);
        });

        var image = newRow.querySelector('[data-compare-product-image]');
        if (productImage) {
            image.setAttribute('src', productImage);
        } else {
            image.removeAttribute('src');
        }
        image.setAttribute('alt', record.product_title);

        this.setText(newRow, '[data-compare-product-vendor]', record.vendor || 'Nil');
        this.setText(newRow, '[data-compare-product-title]', record.product_title);
        this.setText(newRow, '[data-compare-product-price]', record.money_price);
        this.setText(
            newRow,
            '[data-compare-product-availability]',
            record.available ? wdtTheme.strings.in_stock : window.variantStrings.soldOut
        );
        this.setText(newRow, '[data-compare-product-type]', record.type || 'Nil');

        newRow.querySelector('[data-compare-remove]').setAttribute('data-product_handle', record.product_handle);

        var cartLink = newRow.querySelector('[data-compare-product-cart-link]');
        if (variantId) {
            cartLink.setAttribute('data-product-variant-id', variantId);
        } else {
            cartLink.removeAttribute('data-product-variant-id');
        }

        return rowFragment;
    }

    setText(root, selector, value) {
        var element = root.querySelector(selector);
        if (element) element.textContent = String(value || '');
    }

    getSafeProductUrl(url, handle) {
        var fallback = '/products/' + encodeURIComponent(handle);

        try {
            var parsedUrl = new URL(url || fallback, window.location.origin);
            if (parsedUrl.origin === window.location.origin && parsedUrl.pathname.indexOf('/products/') === 0) {
                return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
            }
        } catch (error) {
            return fallback;
        }

        return fallback;
    }

    getSafeImageUrl(url) {
        if (!url) return '';

        try {
            var parsedUrl = new URL(url, window.location.origin);
            if (parsedUrl.protocol === 'https:' || (parsedUrl.protocol === 'http:' && window.location.protocol === 'http:')) {
                return parsedUrl.href;
            }
        } catch (error) {
            return '';
        }

        return '';
    }

    connectedCallback() {
        this.initLoad();
    }
}

customElements.define('dtx-compare-grid', dTXComparetGrid);

class dTXRemoveCompareItem extends HTMLElement {
    constructor() {
        super();

        this.removeItem = this.querySelector('.btn-close');

        this.debouncedOnSubmit = debounce((event) => {          
            this.removeListItem(event);          
        let currentElement = this.parentElement;
        currentElement.classList.add('d-none');        
        let topLevelParent = currentElement.parentElement; 
        if (topLevelParent) {
            topLevelParent.classList.add('d-none');
        }          
        }, 500);

        this.grid_type = this.getAttribute('grid_type');
        this.productHandle = this.removeItem.getAttribute('data-product_handle');

        this.removeItem.addEventListener('click',this.debouncedOnSubmit.bind(this));
    }

    removeListItem(event) {
        event.preventDefault();

        var dTCompareList = new dT_CompareList();
        if ("compareList" == this.grid_type) {
            dTCompareList.setListLocalStorageKey('dt-compare-list', ',');
        }
        dTCompareList.removeComparet(this.productHandle);

        var itemRow = document.getElementById('row_' + this.productHandle);
        if (itemRow) {
            itemRow.parentNode.removeChild(itemRow);
        }
      
        // Update the compare count
        var compareCountElements = document.querySelectorAll(".dtxc-compare-count");
        compareCountElements.forEach(element => {
            element.setAttribute('count', dTCompareList.getTotalCount());
            if (dTCompareList.getTotalCount() === 0) {
                element.classList.add('count-zero');
                element.classList.remove('count-exist');
            } else {
                element.classList.remove('count-zero');
                element.classList.add('count-exist');
            }
        });

        // Check if the table is empty and show no record message
        if (dTCompareList.getTotalCount() === 0) {
            var dtxTable = document.querySelector(".dtx-table");
            var dtxNoRecord = document.querySelector(".dtx-grid-empty");
            dtxTable.classList.add("d-none");          
           setTimeout(() => {
            dtxNoRecord.classList.remove("dtx-grid-hide");
            dtxNoRecord.classList.add("dtx-grid-show");
             }, 500); 
            
        }
    }
}

customElements.define('dtx-remove-compare-item', dTXRemoveCompareItem);

class dTXCompareCount extends HTMLElement {
    static get observedAttributes() {
        return ['count'];
    }

    constructor() {
        super();

        this.gridCountBubble = this.querySelector('.grid-count-bubble');
        this.grid_type = this.getAttribute('grid_type');
        this.initLoad();
    }

    initLoad() {
        var dTCompareList = new dT_CompareList();
        if ("compareList" == this.grid_type) {
            dTCompareList.setListLocalStorageKey('dt-compare-list', ',');
        }

        var totalCount = dTCompareList.getTotalCount();
        this.gridCountBubble.querySelector("span").textContent = totalCount;

        const loadCount = this.gridCountBubble.querySelector("span").textContent;
        if (parseInt(loadCount) == 0) {
            document.querySelector('.dtxc-compare-count').classList.add('count-zero');
        } else {
            document.querySelector('.dtxc-compare-count').classList.add('count-exist');
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        this.initLoad();
    }
}

customElements.define('dtx-compare-count', dTXCompareCount);


